const post = {
  id: 3,
  title: 'Site Update 2.0 — Life Lately',
  date: 'June 2026',
  excerpt: "A lot has changed since I first launched this portfolio. I got married, went back to school full time, and rebuilt this site from the ground up. Here's what's new.",
  body: `If you've been here before, you'll notice things look a little different. That's because this is version 2.0 — a full rebuild of my portfolio with a cleaner design, better structure, and content that actually reflects where I am now.

A lot has happened since the first version went live.

The biggest news: I got married. It's been one of the best things to happen to me, and it's given me a new sense of direction and purpose in everything I do — including how I approach my career.

I also went back to school full time. Balancing coursework with life as a newlywed and a working developer is no small task, but the Army taught me how to manage competing priorities. I'm leaning into that. The degree is the goal and I'm locked in.

On the technical side, version 2.0 of this site is something I'm genuinely proud of. Better component structure, cleaner data management, and a design I actually want to show people. The blog section now pulls from individual post files instead of one giant data dump — small thing, but it's the kind of detail that matters to me.

A lot is in motion right now. School, life, and code. I'll keep showing up for all of it. Later.`,
  readTime: '3 min read',
  tags: ['Life', 'Update', 'Personal'],
};

export default post;
